import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { productTargetsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_stacktrace/planning-operations-core/product-targets/')({
  validateSearch: zodValidator(productTargetsSearchSchema)
});